import type { CronScheduleDef, GencowProcedureDef } from "@gencow/core";
import { computeCronActionToken } from "@gencow/core";

export function buildActionTokenMap(params: {
  cronSchedules: readonly CronScheduleDef[];
  deployId: string;
  internalProcedureMap?: Map<string, GencowProcedureDef<"internal", any, any, any>>;
  allowTransitionProcedureNames?: boolean;
}): Map<string, string> {
  const actionTokenMap = new Map<string, string>();
  for (const schedule of params.cronSchedules) {
    if (
      params.internalProcedureMap &&
      !params.internalProcedureMap.has(schedule.procedureName) &&
      params.allowTransitionProcedureNames !== true
    ) {
      throw new Error(`Cron "${schedule.name}" references unknown internal procedure "${schedule.procedureName}"`);
    }
    const token = computeCronActionToken({
      kind: "declarative",
      deployId: params.deployId,
      name: schedule.name,
      pattern: schedule.pattern,
      procedureName: schedule.procedureName,
    });
    actionTokenMap.set(token, schedule.procedureName);
  }
  return actionTokenMap;
}
